import { useState } from 'react'

/**
 * This hook adds an extra HTML attribute to the input field 
 *      to identify whether user clicked on the input or not.
 * Based on the attribute added to html we can show our error message
 * 
 * Uses 'OnBlur' event to trigger the change in HTML tag 
 */

const useInputValidation = () => {
    const [fieldTouched, setFieldTouched] = useState<any>({})
    
    /** Adding input 'name' attribute to state and setting the value to true*/
    const handleFieldTouch = (ev: any) => {
        setFieldTouched({
            ...fieldTouched,
            [ev.target.name]: true
        })
    }
    
    /** Returning the values to bind to the particular HTML input element*/
    const bindValue = (fieldName: string) => ({
        'data-touched': fieldTouched[fieldName],
        onBlur: handleFieldTouch
    })
    
    /** Resetting state */
    const reset = () => setFieldTouched({})

    return {bindValue, reset}
}

export default useInputValidation